import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import styles from './PostcodeAutocomplete.module.css';
import { MapPin } from 'lucide-react';

// The component now accepts 'onSuggestionSelect' to pass back a structured object
const PostcodeAutocomplete = ({ value, onSuggestionSelect, disabled }) => {
  const [inputValue, setInputValue] = useState(value);
  const [suggestions, setSuggestions] = useState([]);
  const [state, setState] = useState(''); // State to hold the state (e.g., "NSW")
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchSuggestions = async (searchTerm) => {
    if (searchTerm.length === 4 && /^\d{4}/.test(searchTerm)) {
      try {
        // --- THIS IS THE KEY CHANGE ---
        // The API now returns an object: { state: "...", suburbs: [...] }
        const response = await axios.get(`${API_BASE_URL}/api/GooglePlaces/suggestSuburb?postCode=${searchTerm}`);

        console.log();
        
        if (response.data && response.data.suburbs) {
          setSuggestions(response.data.suburbs);
          setState(response.data.state); // Store the state
          setIsOpen(true);
        } else {
          setSuggestions([]);
          setIsOpen(false);
        }
      } catch (error) {
        console.error('Error fetching postcode suggestions:', error);
        setSuggestions([]);
        setIsOpen(false);
      }
    } else {    
      setSuggestions([]);
      setIsOpen(false);
    }
  };

const handleInputChange = (e) => {
    const term = e.target.value;
    // 1. Always update the input field's state to keep it responsive.
    setInputValue(term);
    // 2. Let fetchSuggestions decide if the term is valid for an API call.
    fetchSuggestions(term);
};


const handleSuggestionClick = (suburb) => {
    const postcode = inputValue.match(/^\d{4}/)?.[0] || inputValue;
    const fullSuggestion = `${postcode}, ${suburb}`;
    
    // THE FIX: Check if the prop is a function before calling it.
    if (typeof onSuggestionSelect === 'function') {
      onSuggestionSelect({
        fullAddress: fullSuggestion,
        postcode: postcode,
        suburb: suburb,
        state: state
      });
    }

    setInputValue(fullSuggestion);
    setSuggestions([]);
    setIsOpen(false);
};

  return (
    <div className={styles.autocompleteWrapper} ref={wrapperRef}>
      <div className={styles.inputWithIconContainer}>
        <MapPin className={styles.inputIcon} />
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="Enter 4-digit postcode..."
          disabled={disabled}
          className={styles.input}
        />
      </div>
      {isOpen && suggestions.length > 0 && (
        <ul className={styles.suggestionsList}>
          <li className={styles.suggestionHeader}>Select a suburb for {inputValue}:</li>
          {suggestions.map((suburb, index) => (
            <li
              key={index}
              onClick={() => handleSuggestionClick(suburb)}
              className={styles.suggestionItem}
            >
              {suburb}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PostcodeAutocomplete;